import { Box } from '@mui/material'
import PartnersList from './PartnersList'
import { useEffect } from 'react'
import { useMultiRole } from '@/concepts/Admin/hooks/useMultiRole'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
    gap: '20px'
  }
}

export const MultiRolePartner = () => {
  const { partners, fetchMultiRolePartners, selectPartner } = useMultiRole()

  useEffect(() => {
    fetchMultiRolePartners()
  }, [])

  return (
    <Box sx={styles.container}>
      <PartnersList partners={partners} onClick={selectPartner} admin={false} />
    </Box>
  )
}
